import { render, staticRenderFns } from "./Popover.vue?vue&type=template&id=085556ba&scoped=true&"
import script from "./Popover.vue?vue&type=script&lang=js&"
export * from "./Popover.vue?vue&type=script&lang=js&"
import style0 from "./Popover.vue?vue&type=style&index=0&id=085556ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../commerce-care/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085556ba",
  null
  
)

export default component.exports